<template>
    <div class="login-panel">
        <div class="card card-auth with-shadow">
            <h2 class="auth-heading">
                Login to your account
                <span> Please enter your account credentials. </span>
            </h2>

            <div class="auth-body">
                <b-form @submit.stop.prevent="onSubmit">
                    <b-form-group
                        id="login_username"
                        label="Username"
                        label-for="login-username-input"
                    >
                        <b-form-input
                            id="login_username"
                            v-model="formData.username"
                            v-validate="{ required: true, max: 20, min: 6 }"
                            placeholder="Enter your account username"
                            autocomplete="off"
                            data-vv-name="username"
                            :class="{
                                'is-invalid': errors.has('username'),
                            }"
                        ></b-form-input>
                    </b-form-group>
                    <b-form-group
                        id="login_password"
                        label="Password"
                        type="password"
                        label-for="login-password-input"
                    >
                        <b-form-input
                            id="login-password-input"
                            v-model="formData.password"
                            v-validate="{ required: true, max: 20, min: 6 }"
                            placeholder="Enter your account password"
                            autocomplete="off"
                            type="password"
                            data-vv-name="password"
                            :class="{
                                'is-invalid': errors.has('password'),
                            }"
                        ></b-form-input>
                    </b-form-group>
                    <base-button
                        btn-label="Sign In"
                        btn-type="submit"
                        btn-variant="primary"
                        :disabled="loading"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <router-link
                        to="auth/forgot-password"
                        class="btn forgot-link btn-link float-right"
                        >Forgot your password?</router-link
                    >
                    <!-- <base-toast></base-toast> -->
                </b-form>
            </div>
        </div>
        <b-modal 
            ref="otpmodal"
            size="sm"
            title=""
            hide-footer
            :click-to-close="false"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
            @close="onCloseOTPModal"
        >
            <otp-verification-modal
                :data="otpData"
                @verificationStatus="otpResponse"
                @reSendOTP="reSendOTP"
            ></otp-verification-modal>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import resource from '@/api/resource'
const viewBrandingApi = new resource('configurations/branding')
import OtpVerificationModal from '../../components/popups/OTPModal.vue'
import request from '@/utils/request'
import jwt_decode from 'jwt-decode'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        OtpVerificationModal,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            formData: this.initializeFormData(),
            otpData: null,
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'user', 'success', 'redirectUrl', 'hasOTP']),
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */

    watch: {
        /**
         * Handle when the user has been updated
         *
         * @return {void}
         */
        user(value) {
            // check if the value is not empty
            // and redirect to inner page
            if (value !== null && value !== undefined) {
                if (this.redirectUrl) {
                    this.$router.push({ path: this.redirectUrl })
                    this.$store.commit('setRedirectUrl', null)
                } else {
                    this.$router.push({ name: 'view-alerts' })
                }
            }
        }, // End of user()
    }, // End of Component > methods

    /*
        |--------------------------------------------------------------------------
        | Component > mounted
        |--------------------------------------------------------------------------
        */
    async created() {
        // Change theme color
        await this.getBrandingData()
    }, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        initializeFormData() {
            return {
                username: '',
                password: '',
            }
        }, // End of initializeFormData() methods

        async onSubmit() {
            const result = await this.$validator.validateAll()

            if (result) {
                try {
                    let encryptedForm = this.CryptoJS.AES.encrypt(
                        JSON.stringify(this.formData),
                        process.env.VUE_APP_CRYPTO_SECERT_KEY
                    ).toString()

                    const isValid = await this.$store.dispatch(
                        'verifyCredentials',
                        {
                            data: encryptedForm,
                        }
                    )

                    if (isValid && (this.hasOTP || this.hasOTP === undefined)) {
                        this.sendOTP()
                    } else {
                        const response = await this.$store.dispatch('authLogin', {
                        data: encryptedForm,
                        })
                        if (response.status == 200) {
                        // OTP verified and user logged in successfully
                        if (this.redirectUrl) {
                            this.$router.push({ path: this.redirectUrl })
                            this.$store.commit('setRedirectUrl', null)
                            this.$store.commit('setOTP', null)
                            
                        } else {
                            this.$router.push({ name: 'view-alerts' })
                            this.$store.commit('setOTP', null)

                        }
                    }
                    }
                } catch (error) {
                    console.log(error, 'There is an error on login submit')
                }
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() method

        async sendOTP() {
            try {
                // let dataSegmentId = this.dataSegmentId

                this.$store.commit('setLoading', true)
                this.$store.commit('setOTP', null)

                const { data } = await request({
                    url: `/configurations/generate-otp/`,
                    method: 'post',
                    data: this.formData,
                })
                if (data) {
                    this.otpData = data

                    this.$refs.otpmodal.show()
                }

                // this.showPageLoader = false
                // this.fields = data.data
            } catch (error) {
                console.log('OTP error: ' + error)
            }

            this.$store.commit('setLoading', false)
            this.$store.commit('setOTP', null)

        }, // End of sendOtp() method

        async otpResponse(data, otp) {
            this.$store.commit('setLoading', true)

            try {
                // Check if the token is expired
                const currentTime = Math.floor(Date.now() / 1000) // Current time in seconds
                if (data.exp < currentTime) {
                    throw new Error('Token has expired')
                }

                if (data.status === 200) {
                    this.formData.otpCode = otp
                    this.$store.commit('updateField', {
                        key: 'otpCode',
                        value: otp,
                    })

                    let encryptedForm = this.CryptoJS.AES.encrypt(
                        JSON.stringify(this.formData),
                        process.env.VUE_APP_CRYPTO_SECERT_KEY
                    ).toString()

                    // authLogin action in auth store
                    const response = await this.$store.dispatch('authLogin', {
                        data: encryptedForm,
                    })
                    if (response.status == 200) {
                        // OTP verified and user logged in successfully
                        if (this.redirectUrl) {
                            this.$router.push({ path: this.redirectUrl })
                            this.$store.commit('setRedirectUrl', null)
                            this.$store.commit('setOTP', null)
                        } else {
                            this.$router.push({ name: 'view-alerts' })
                            this.$store.commit('setOTP', null)
                        }
                    }
                } else {
                    this.$store.commit(
                        'setError',
                        'Your code is invalid, try again!'
                    )
                }
            } catch (error) {
                console.error('Error during OTP verification:', error)
                this.$store.commit(
                    'setError',
                    error.message || 'OTP verification failed'
                )
            } finally {
                this.$store.commit('setLoading', false)
                this.$store.commit('setOTP', null)

            }
        },

        async reSendOTP() {
            this.sendOTP()
        }, // End of reSendOTP() method
        async getBrandingData() {
            let { data } = await viewBrandingApi.list()
            this.$store.commit('setDisplaySetting', data.data)
        }, // End of getBrandingData() method

        onCloseOTPModal() {
            this.$store.commit('setLoading', false)
            this.$store.commit('setOTP', null)
        }, // End of pnCloseOTPModal() method
    }, // End of Component > mounted
} // End of export default
</script>
